/**
 * Updates the recently viewed products in localStorage.
 */
export class RecentlyViewed {
  /** @static @constant {string} The key used to store the viewed products in localStorage */
  static #STORAGE_KEY = 'viewedProducts';
  /** @static @constant {number} Default history limit used by predictive search */
  static #MAX_PRODUCTS = 4;

  /**
   * Adds a product to the recently viewed products list.
   * @param {string} productId - The ID of the product to add.
   * @param {number} [maxProducts] - Storage capacity, including the current product.
   */
  static addProduct(productId, maxProducts = this.#MAX_PRODUCTS) {
    if (!/^\d+$/.test(productId)) return;
    let viewedProducts = this.getProducts(maxProducts);

    viewedProducts = viewedProducts.filter((/** @type {string} */ id) => id !== productId);
    viewedProducts.unshift(productId);
    viewedProducts = viewedProducts.slice(0, maxProducts);

    try {
      localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(viewedProducts));
    } catch {
      // Storage may be disabled or full. Product pages must remain usable.
    }
  }

  static clearProducts() {
    try {
      localStorage.removeItem(this.#STORAGE_KEY);
    } catch {
      // Storage may be disabled.
    }
  }

  /**
   * Retrieves unique product IDs from localStorage, newest first.
   * @param {number} [limit] - Maximum number of IDs to return.
   * @returns {string[]} The list of viewed products.
   */
  static getProducts(limit = this.#MAX_PRODUCTS) {
    try {
      const products = JSON.parse(localStorage.getItem(this.#STORAGE_KEY) || '[]');
      if (!Array.isArray(products)) return [];
      return [...new Set(products.filter((id) => typeof id === 'string' && /^\d+$/.test(id)))].slice(0, limit);
    } catch {
      return [];
    }
  }
}
